import { SmartCaptcha } from '@yandex/smart-captcha';

export const YandexCaptcha = ({ onTokenChange }) => {
    return <>
        <div className="yandex-captcha">
            <SmartCaptcha sitekey={process.env.REACT_APP_YANDEX_CAPTCHA_CLIENT_KEY} onSuccess={onTokenChange} />
        </div>
    </>
};
